module.exports = __webpack_public_path__ + "assets/img/btn-detail-92082da6.png";